import { define } from 'wicked-elements'

define('[data-component="sticky-column"]', {
  init() {
    this.update = this.update.bind(this)
  },
  connected() {
    this.update()
    window.addEventListener('resize', this.update)
  },
  disconnected() {
    window.removeEventListener('resize', this.update)
  },
  update() {
    const windowHeight = window.innerHeight
    const columnHeight = this.element.offsetHeight
    if (columnHeight > (windowHeight * .9)) {
      this.element.classList.remove('sticky')
    } else {
      this.element.classList.add('sticky')
    }
  }
})